const FOCUSABLE =
  'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

export interface FocusTrapHandle {
  release(): void;
}

export function trapFocus(container: HTMLElement): FocusTrapHandle {
  const previouslyFocused = document.activeElement as HTMLElement | null;

  function focusables(): HTMLElement[] {
    return Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE)).filter(
      (el) => !el.hasAttribute("aria-hidden") && el.offsetParent !== null,
    );
  }

  function onKey(e: KeyboardEvent): void {
    if (e.key !== "Tab") return;
    const nodes = focusables();
    if (nodes.length === 0) {
      e.preventDefault();
      container.focus();
      return;
    }
    const first = nodes[0] as HTMLElement;
    const last = nodes[nodes.length - 1] as HTMLElement;
    const active = document.activeElement as HTMLElement | null;
    if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  }

  container.addEventListener("keydown", onKey);

  const nodes = focusables();
  if (nodes.length > 0) (nodes[0] as HTMLElement).focus();
  else {
    container.setAttribute("tabindex", "-1");
    container.focus();
  }

  return {
    release() {
      container.removeEventListener("keydown", onKey);
      if (previouslyFocused && typeof previouslyFocused.focus === "function") {
        previouslyFocused.focus();
      }
    },
  };
}
